import { supabase } from "./supabase";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

/**
 * Fire-and-forget call to the log-password-event edge function.
 * Errors are silently caught so they never block the user flow.
 */
export async function logPasswordEvent(
  event: string,
  payload: Record<string, string> = {},
  options?: { authenticated?: boolean },
) {
  try {
    if (options?.authenticated) {
      // Use the supabase client which auto-injects the JWT
      await supabase.functions.invoke("log-password-event", {
        body: { event, ...payload },
      });
    } else {
      // Unauthenticated call — manual fetch with anon key as both apikey and Bearer token
      await fetch(`${SUPABASE_URL}/functions/v1/log-password-event`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          apikey: SUPABASE_ANON_KEY,
          Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
        },
        body: JSON.stringify({ event, ...payload }),
      });
    }
  } catch {
    // Never block the user flow for logging failures
  }
}
